import { combineReducers } from "redux";

import { internal } from "lib/reducers/InternalReducer";
import { ui } from "lib/reducers/UIReducer";
import { buildRecordReducer } from "lib/reducers/ReducerTemplates";

var rootReducer = combineReducers({
	internal,
	ui,
	activities: buildRecordReducer("activities"),
	admins: buildRecordReducer("admins"),
	avatars: buildRecordReducer("avatars"),
	answers: buildRecordReducer("answers"),
	books: buildRecordReducer("books", { idKey: "text_id" }),
	comments: buildRecordReducer("comments"),
	contacts: buildRecordReducer("contacts"),
	deals: buildRecordReducer("deals"),
	digests: buildRecordReducer("digests", { idKey: "key" }),
	discountTokens: buildRecordReducer("discountTokens", { idKey: "code" }),
	districtOrgs: buildRecordReducer("districtOrgs"),
	estimates: buildRecordReducer("estimates"),
	evaluations: buildRecordReducer("evaluations"),
	exercises: buildRecordReducer("exercises"),
	coinRecords: buildRecordReducer("coinRecords"),
	invoices: buildRecordReducer("invoices"),
	logs: buildRecordReducer("logs"),
	parents: buildRecordReducer("parents"),
	patches: buildRecordReducer("patches"),
	photographs: buildRecordReducer("photographs"),
	platforms: buildRecordReducer("platforms"),
	perks: buildRecordReducer("perks"),
	furnitures: buildRecordReducer("furnitures"),
	questions: buildRecordReducer("questions"),
	quizzes: buildRecordReducer("quizzes"),
	ratings: buildRecordReducer("ratings"),
	readingLevels: buildRecordReducer("readingLevels"),
	reports: buildRecordReducer("reports", { idKey: "report_key" }),
	responses: buildRecordReducer("responses"),
	schoolOrgs: buildRecordReducer("schoolOrgs"),
	schools: buildRecordReducer("schools", { idKey: "l2e_id" }),
	studentLists: buildRecordReducer("studentLists"),
	students: buildRecordReducer("students"),
	tasks: buildRecordReducer("tasks"),
	upgradeTokens: buildRecordReducer("upgradeTokens"),
	surveyPrompts: buildRecordReducer("surveyPrompts", { idKey: "key" }),
	widgetDigests: buildRecordReducer("widgetDigests"),
});

module.exports = {
	rootReducer,
};



// WEBPACK FOOTER //
// ./modules/lib/reducers/RootReducer.js